"use client";
import React from "react";
import CommonLayout from "./CommonLayout";
import Img_2 from "../../assets/dummy/img_4.png";
import Img_3 from "../../assets/dummy/img_5.jpg";
import Img_4 from "../../assets/icon/bikeIcon.png";
import Img_5 from "../../assets/icon/scooterIcon.png";
import Image from "next/image";
import HeadingAndSubHeading from "./HeadingAndSubHeading";
import SearchRedirectBtn from "@/components/redirect_btn/SearchRedirectBtn";
import { MoveRight } from "lucide-react";
import { CoverSection } from "../../types/homepage";


const Covered: React.FC<{ data?: CoverSection; cityName?: string }> = ({ data, cityName }) => {
  // Map Sanity data to local images
  const getImageForCard = (title: string, type: 'img' | 'icon') => {
    const titleLower = title.toLowerCase();
    if (titleLower.includes('bike')) {
      return type === 'img' ? Img_3 : Img_4;
    } else if (titleLower.includes('scooter')) {
      return type === 'img' ? Img_2 : Img_5;
    }
    // Default fallback
    return type === 'img' ? Img_3 : Img_4;
  };

  const getAnalyticsName = (title: string) => {
    const titleLower = title.toLowerCase();
    if (titleLower.includes('bike')) {
      return "bike_rentals_button";
    } else if (titleLower.includes('scooter')) {
      return "scooter_rentals_button";
    }
    return "default_rentals_button";
  };

  // Use Sanity data if available, otherwise fallback to hardcoded cards
  const cards = data?.cards?.map(card => ({
    price: card.price,
    imgUrl: getImageForCard(card.title, 'img'),
    iconUrl: getImageForCard(card.title, 'icon'),
    analyticsName: getAnalyticsName(card.title),
    buttonText: card.title,
  })) || [
    {
      price: "₹500/day",
      imgUrl: Img_3,
      iconUrl: Img_4,
      analyticsName: "bike_rentals_button",
      buttonText: "Bike Rentals",
    },
    {
      price: "₹500/day",
      imgUrl: Img_2,
      iconUrl: Img_5,
      analyticsName: "scooter_rentals_button",
      buttonText: "Scooter Rentals",
    },
  ];
  return (
    <div className="bg-white">
      <CommonLayout className="py-[50px] md:py-[70px] ">
        <HeadingAndSubHeading
          heading={data?.heading || (cityName ? `RENT IN ${cityName.toUpperCase()}` : "BIKES OR SCOOTERS?")}
          subHeading={data?.subHeading || (cityName ? `Bikes & scooters in ${cityName}` : "We've got you covered")}
        />

        <div className="flex items-start justify-between flex-wrap gap-8 md:gap-0 mt-8">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="relative rounded-4xl border border-gray-200 w-full md:w-[49%] text-center overflow-hidden"
            >
              <div className="w-full h-[300px] md:h-[400px] relative">
                <Image
                  src={card.imgUrl}
                  alt={`card_${idx}`}
                  fill
                  sizes="(max-width: 768px) 100vw, 49vw"
                  className="object-cover rounded-4xl"
                  priority={idx < 2}
                  placeholder="blur"
                  blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkMjU1LS0yMi4qLjgyPj4+Oj5CQkJCQkJCQkJCQkJCQkJCQkJCQkL/2wBDAR4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
                />
              </div>

              {/* Overlay Layer */}
              <div className="absolute inset-0 bg-black opacity-30 z-4 rounded-4xl" />

              {/*content  */}
              <div className="absolute inset-0 z-5 p-4 md:p-8 flex flex-col justify-between">
                <button className="flex items-center justify-center w-fit px-4 py-2 h-10 bg-white hover:bg-gray-100 border border-gray-200 rounded-full cursor-pointer text-black">
                  <Image
                    src={card.iconUrl}
                    alt={`card_${idx}`}
                    className="w-8 h-8 mr-2"
                    width={32}
                    height={32}
                    style={{ width: 'auto', height: 'auto' }}
                  />
                  {card.buttonText}
                </button>
                <div className="w-full flex items-center justify-between z-10">
                  <div>
                    <p className="text-gray-400 text-[14px] lg:text-[16px] font-normal">
                      Starting from{" "}
                      <span className="text-white">{card.price}</span>
                    </p>
                  </div>
                  <SearchRedirectBtn analyticsName={card.analyticsName} buttonText={card.buttonText}>
                    <MoveRight className="text-white"/>
                  </SearchRedirectBtn>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CommonLayout>
    </div>
  );
};

export default Covered;
